'use client';

// Affiche les règles de mot de passe (cahier §4.1) avec validation en direct.
// Purement indicatif — le backend reste juge (uncompromised HIBP inclus).

import { Check, X } from 'lucide-react';

import { useT } from '@/hooks/useT';
import { fontStyle } from '@/theme/typography';

interface Rule {
  key: string;
  test: (v: string) => boolean;
}

const RULES: Rule[] = [
  { key: 'length', test: (v) => v.length >= 12 },
  { key: 'case', test: (v) => /[a-z]/.test(v) && /[A-Z]/.test(v) },
  { key: 'number', test: (v) => /\d/.test(v) },
  { key: 'symbol', test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export function PasswordPolicyHint({ password }: { password: string }) {
  const { t } = useT('auth');

  return (
    <ul className="flex flex-col gap-1">
      {RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li key={rule.key} className="flex items-center gap-2">
            {ok ? (
              <Check className="size-4 text-success" aria-hidden />
            ) : (
              <X className="size-4 text-text-tertiary" aria-hidden />
            )}
            <span style={fontStyle('bodySm')} className={ok ? 'text-success' : 'text-text-tertiary'}>
              {t(`password.${rule.key}`)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
